import styled, { css } from 'styled-components';

export const NormalButtom = styled.button`
  background-color: ${(props) => props.theme.colors.normalButtonBackgroundColor};
  border: 0;
  border-radius: 20px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.normalButtonTextColor};
  height: 38px;
  padding: 0 33px;
  cursor: pointer;
  border-width: 0;

  &:hover{
    background-color: ${(props) => props.theme.colors.normalButtonHoverBackgroundColor};
    color: ${(props) => props.theme.colors.normalButtonHoverTextColor};
  }

  ${({ clickable }) => !clickable ? css`
    pointer-events: none;
    background: #202529;
    color: #FFF;
    opacity: 0.6;
  ` : ''}

  ${({ disable }) => disable ? css`
    cursor: not-allowed !important;
    pointer-events: none;
    background-color: #EBEAEA !important;
    color: #6B7986 !important;
  ` : ''}

`;

export const ClearButtom = styled.button`
  background-color: ${(props) => props.theme.colors.clearButtonBackgroundColor};
  border: 0;
  border-radius: 20px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.clearButtonTextColor};
  height: 38px;
  padding: 0 33px;
  cursor: pointer;
  border-width: 0;

  &:hover{
    background-color: ${(props) => props.theme.colors.clearButtonHoverBackgroundColor};
    color: ${(props) => props.theme.colors.clearButtonHoverTextColor};
  }

  ${({ clickable }) => !clickable ? css`
    pointer-events: none;
    background: #202529;
    color: #FFF;
    opacity: 0.6;
  ` : ''}

  ${({ disable }) => disable ? css`
    cursor: not-allowed !important;
    background: #EBEAEA !important;
    color: #6B7986 !important;
  ` : ''}
`;
